var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.675,
    height: 31.675,
    viewBox: "0 0 31.675 31.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff4e4e;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.b{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-516.163 -156.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M362.851,248.893a15.338,15.338,0,1,0-15.337,15.337A15.355,15.355,0,0,0,362.851,248.893Z",
    transform: "translate(184.487 -76.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.707,16.707a1,1,0,0,1-1.414,0L12,13.414,8.707,16.707a1,1,0,0,1-1.414-1.414L10.586,12,7.293,8.707A1,1,0,0,1,8.707,7.293L12,10.586l3.293-3.293a1,1,0,0,1,1.414,1.414L13.414,12l3.293,3.293A1,1,0,0,1,16.707,16.707Z",
    transform: "translate(520 160.002)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestCanceled);
export default __webpack_public_path__ + "static/media/request-canceled.6f5ceddd05fa3c8f11a923c9fa6ce4c6.svg";
export { ForwardRef as ReactComponent };